import { Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { BehaviorSubject, Observable } from 'rxjs';
import { IdleStateEnum } from '../dtos/idle-state.enum';

@Injectable({
    providedIn: 'root'
})
export class IdleDetectingService {
    private readonly IDLE_INTERVAL = 1800;
    private readonly TIMEOUT_INTERVAL = 1800;
    private readonly KEEP_ALIVE_INTERVAL = 2;
    private readonly _idleState = new BehaviorSubject<IdleStateEnum>(IdleStateEnum.NOT_IDLE);
    public idleState$ = this._idleState.asObservable();

    public getIdleState(): Observable<IdleStateEnum> {
        return this.idleState$;
    }

    // source: https://moribvndvs.github.io/ng2-idle/quickstart, https://www.npmjs.com/package/@ng-idle/core
    public constructor(private idle: Idle, private keepalive: Keepalive) {
        // set idle parameters
        idle.setIdle(this.IDLE_INTERVAL); // how long can they be inactive before considered idle, in seconds
        idle.setTimeout(this.TIMEOUT_INTERVAL); // how long can they be idle before considered timed out, in seconds
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // provide sources that will "interrupt" aka provide events indicating the user is active

        // do something when the user becomes idle
        idle.onIdleStart.subscribe(() => {
            this._idleState.next(IdleStateEnum.IDLE);
        });
        // do something when the user is no longer idle
        idle.onIdleEnd.subscribe(() => {
            this._idleState.next(IdleStateEnum.NOT_IDLE);
        });
        // do something when the user has timed out
        idle.onTimeout.subscribe(() => this._idleState.next(IdleStateEnum.TIMED_OUT));

        // set keepalive parameters, omit if not using keepalive
        keepalive.interval(this.KEEP_ALIVE_INTERVAL); // will ping at this interval while not idle, in seconds
        keepalive.onPing.subscribe(() => this._idleState.next(IdleStateEnum.ACTIVE_CHECK)); // ping server to make sure user still active
    }

    public reset(): void {
        this.idle.stop();
        this.idle.watch();
        this._idleState.next(IdleStateEnum.NOT_IDLE);
    }
}
